import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import FormSelect from "../../../Components/FormTag/FormSelect";
import OffCanvas from "../../../Components/FormTag/OffCanvas";
import Loader from "../../../Components/GlobalLoader/Loader";
import { Column } from "../../../Components/Tables/Table";
import { formatDate, formatNumber, prepareSearchColumns } from "../../../Utility/Utility";
import { useGlobalFilter } from "../../../hooks/useGlobalFilter";
import { TabConfig } from "../../../model/common/tabs";
import { useSearchStore } from "../../../store/search/searchStore";
import { asnAdvanceFilter } from "../../ASN/Check-In/CheckIn.type";
import ShimpmentList from "./list/ShipmentList";
import { ShimpmentQuery } from "./model/shipment.model";
import useWarehouseStore from "../../../store/warehouse/useWarehouseStore";
import useClientStore from "../../../store/client/useClientStore";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";
import { deallocateShipmentById } from "./service/shipments.service";
import { toast, Toaster } from "react-hot-toast";



export default function ShippingOverview() {
  const navigation = useNavigate();
  const {resetSearch } =
    useSearchStore();
  const [loading, setLoading] = useState(true);
  const pageName = "Shipments";
  const [advancedFilterData, setAdvancedFilterData] = useState<any>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [supplierData, setSupplierData] = useState<any>();
  const buttonStatus = true;
  const [clientId, setClientId] = useState<any>(null);
  const advanceFilterMapper:any = {
    "supplier" : "supplier.code"
  }
    const [showConfModal, setShowConfModal] = useState(false);
  const [selectedShipmentId, setSelectedShipmentId] = useState<number | null>(null);
  const [isDeallocating, setIsDeallocating] = useState(false);

  const handleConfClose = () => {
    setShowConfModal(false);
    setSelectedShipmentId(null);
    setIsDeallocating(false);
  };

  const onModalSubmit = (isConfirm: boolean) => {
    if (isConfirm && selectedShipmentId && !isDeallocating) {
      setIsDeallocating(true);
      onDeallocateSubmit(true);
    } else {
      handleConfClose();
    }
  };

  const {
    isShowCanvas,
    toggleFilter,
    handleFilterCount,
    activeFilterCount,
  } = useGlobalFilter();
  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors },
  } = useForm<asnAdvanceFilter>({
    defaultValues: new asnAdvanceFilter(),
  });
  const { getSelectedWarehouse } = useWarehouseStore();
  const { getSelectedClient } = useClientStore();

  useEffect(() => {
    const subscriptionClient = getSelectedClient().subscribe((client) => {
      setClientId(client?.id);
    });

    return () => {
      subscriptionClient.unsubscribe();
    };
  }, [getSelectedClient]);
  const db_columns= [
    {
      "data": "shipment.id"
    },
    {
        "data": "shipment.shipment_number"
    },
    {
        "data": "shipment.no_of_lines"
    },
    {
        "data": "shipment.ship_to_name"
    },
    {
        "data": "shipment.ship_by_date"
    },
    {
        "data": "shipment.total_qty_picked"
    },
    {
        "data": "shipment.total_qty_remaining"
    },
    {
      "data": "shipment.status"
    },
    {
      "data": "shipment.total_qty_requested"
    },
    {
      "data": "customer_bill_to.name"
    }
];
 const [confirmModalData, setConfirmModalData] = useState({
    id: 0,
    showconfModal: false,
    message: ''
  });

  const [deallocateModalData, setDeallocateModalData] = useState({
    id: 0,
    showconfModal: false,
    message: ''
  });

  const handelDeallocateAction = (data: ShimpmentQuery) => {
    setDeallocateModalData({
      id: data.id,
      showconfModal: true,
      message: `You are about to deallocate this shipment number ${data.shipment_number}. Are you sure?`
    });
  };

  const handleDeallocateClose = () => {
    setDeallocateModalData({
      id: 0,
      showconfModal: false,
      message: ''
    });
  };

  const onDeallocateSubmit = async (isAccept: boolean) => {
    // debugger;
    if (deallocateModalData.id !== 0 && isAccept) {
      handleDeallocateClose();
      try {
        const response = await deallocateShipmentById(deallocateModalData.id);
        if (response.status === 200) {
          console.log('response', response);
          toast.success("Shipment deallocated successfully!");
          setTimeout(() => window.location.reload(), 1000);
        } else {
          if (response.error && response.error.detail) {
            toast.error(response.error.detail);
          } else {
            toast.error("Failed to deallocate the shipment!");
          }
        }
      } catch (error: any) {
        const detail =
           error?.response?.data?.detail ||
          error?.message ||
          "Failed to deallocate the shipment!";
        console.log('error', detail);
        toast.error(detail,{ duration: 20000 });
      }
    }
    handleDeallocateClose();
  };

  const exclude_columns = ["shipment.no_of_lines","shipment.total_qty_picked","shipment.total_qty_picked","shipment.total_qty_remaining","shipment.total_qty_requested"];
  const search_columns = prepareSearchColumns(db_columns, exclude_columns);

  const columns: Column[] = [
    {
      name: "Shipment #",
      column_name:"shipment.shipment_number",
      enableSorting:true,
      selector: (row:ShimpmentQuery) => (
          <span className="cursor-pointer text-primary" onClick={()=>handleRowClick(row?.id)}>
          {row?.shipment_number ?? "-"}
        </span>
      ),
    },
    {
      name: "	No. of Lines",
      column_name:"shipment.no_of_lines",
      selector: (row:ShimpmentQuery) =>(
        <>
          {row?.no_of_lines ?? "-"}
        </>
      )
    },
    {
      name: "Bill-to",
      enableSorting:true,
      column_name:"customer_bill_to.name",
      selector: (row:ShimpmentQuery) =>(
        <>
       {row?.name ?? "-"}
        </>
      ),
    },
    {
      name: "Ship-to",
      enableSorting:true,
      column_name:"shipment.ship_to_name",
      selector: (row:ShimpmentQuery) =>(
        <>
       {row?.ship_to_name ?? "-"}
        </>
      ),
    },
    {
      name: "Ship-by Date",
      enableSorting:true,
      column_name:"shipment.ship_by_date",
      selector: (row:ShimpmentQuery) => (
        <>
            {row.ship_by_date ? formatDate(row.ship_by_date): '-'}
        </>
      ),
    },
    {
      name: "Requested Qty",
      column_name:"shipment.total_qty_requested",
      selector: (row:ShimpmentQuery) => (
        formatNumber(row.total_qty_requested)?? 0 
      ),
    },
    {
      name: "Pick Qty",
      column_name:"shipment.total_qty_picked",
      selector: (row:ShimpmentQuery) => (
        <>
          {formatNumber(row?.total_qty_picked) ?? 0}
        </>
      ),
    },
    {
      name: "Remaining Qty",
      column_name:"shipment.total_qty_remaining",
      selector: (row:ShimpmentQuery) => (
        <>
          {formatNumber(row.total_qty_remaining) ?? 0}
        </>
      ),
    },
    {
      name: (<></>),
      selector: (row: ShimpmentQuery) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items px-0 py-1">
            <li
              key={1}
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleRowClick(row.id)}
            >
              View
            </li>
            <li
              key={2}
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelDeallocateAction(row)}
            >
              Deallocate
            </li>
          </ul>
        </>
      ),
    },
  ];
  const pageTabs: TabConfig[] = [
    {
      order: 0,
      name: 'pending',
      tabLable: 'Pending',
      visibility: true,
      status: true,
      multiSelect: null
    },
    {
      order: 1,
      name: 'picking',
      tabLable: 'Picking',
      visibility: true,
      status: false,
      multiSelect: null
    },
    {
      order: 2,
      name: 'packing',
      tabLable: 'Packing',
      visibility: true,
      status: true,
      multiSelect: null
    },
    {
      order: 3,
      name: 'shipping',
      tabLable: 'Shipping',
      visibility: true,
      status: true,
      multiSelect: null
    },
    {
      order: 4,
      name: 'shipped',
      tabLable: 'Shipped',
      visibility: true,
      status: true,
      multiSelect: null
    }
  ];

  const handleRowClick = (id: any) => {
    return navigation(`/outbound/shipments/details/${id}`);
  };
  const handelDetailAction = (id: any) => {
    return navigation(`/outbound/shipments/details/${id}`);
  };


  useEffect(() => {
    resetSearch();
    setLoading(false);
}, [])
  
  const canvasHeader = (
      <div className="d-flex align-items-center gap-1">
        <Dropdown>
          <Dropdown.Toggle
            className="btn bg-white text-dark dropdown-toggle"
            id="dropdown-basic"
          >
            Saved Filter
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1" className="dropdown-toggle-item">
              One line count
            </Dropdown.Item>
            <Dropdown.Item href="#/action-2" className="dropdown-toggle-item">
              Special count
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
  );
  const handleGlobalFilter = () => {
    toggleFilter();
  };
  const nextData: SubmitHandler<asnAdvanceFilter> = (data) => {
    setRefreshTrigger(refreshTrigger + 1);
    handleFilterCount(data);
    setAdvancedFilterData(data);
    toggleFilter();
  };
  
  const handelResetFilter = () => {
    reset(new asnAdvanceFilter());
    handleFilterCount(0);
    toggleFilter();
    setAdvancedFilterData(null);
  }
  const Offcanvas = (
    <OffCanvas
      show={isShowCanvas}
      handleClose={handleGlobalFilter}
      title="Advance Filter"
      headerChildren={canvasHeader}
    >
      <>
        <div className="offcanvas-body offcanvas-height custom-scrollbar">
          <form>
            <div className="">
              <div className="my-3">
                <label>Supplier</label>
                <div>
                  <FormSelect
                    tabIndex={1}
                    name="supplier"
                    control={control}
                    optionList={supplierData ?? []}
                    className="form-control p-0"
                    placeholder="Select"
                    isSearchable={true}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="offcanvs-footer d-flex justify-content-end  px-0 border-top pt-3">
          <button
            className="btn offcanvas-close-btn px-4 mx-2 "
            onClick={() => handelResetFilter()}
          >
            Clear
          </button>
          <button
            className="btn offcanvas-apply-btn px-4 px-2 "
            onClick={handleSubmit(nextData)}
          >
            Apply
          </button>
        </div>
      </>
    </OffCanvas>
  );


  return !loading ? (
    <>
     <Toaster />
    <ShimpmentList
      db_columns={db_columns}
      search_columns={search_columns}
      columns={columns}
      pageName={pageName}
      pageTabs={pageTabs}
      Offcanvas={Offcanvas}
      handleGlobalFilter={handleGlobalFilter}
      buttonStatus={buttonStatus}
      checkboxStatus={false}
      tableMultiSelect={null}
      key={refreshTrigger}
      advancedFilterData={advancedFilterData}
      filterDataCount = {activeFilterCount}
      advanceFilterMapper = {advanceFilterMapper}
      clientId={clientId}
    />
    <CommonConfirmationModal
      customClassName="header-border"
      show={deallocateModalData.showconfModal}
      content={<> {deallocateModalData.message} </>}
      onModalSubmit={onDeallocateSubmit}
      confirmBtnText="Deallocate"
      cancelBtnText="Cancel"
    />
    </>
  ):<Loader/>
}
